import type { ApiRequest, ApiRequestWith } from "@/api/types";
import type {
  CosignaturePermissionMetadata,
  CosignatureSupervisors,
  OptionalPermission,
  RequiredPermission,
  UserPermissions,
} from "@/core/types";
import { httpAuth2 } from "@/api/auth";

export type UpdateUserPermissionsBody = {
  co_sign:
    | OptionalPermission
    | (RequiredPermission &
        Pick<
          CosignaturePermissionMetadata,
          "assigned_supervisor_id" | "requirement_reason" | "requirement_reason_details"
        >);
};

type PermissionsRequestsTyped = {
  get_cosign_supervisors: ApiRequest<CosignatureSupervisors>;
  get_user_permissions: ApiRequestWith<UserPermissions, { urlParams: { userId: string } }>;
  update_user_permissions: ApiRequestWith<
    UserPermissions,
    { body: UpdateUserPermissionsBody; urlParams: { userId: string } }
  >;
};

export const permissionsRequestsTyped: PermissionsRequestsTyped = {
  get_cosign_supervisors: function ({ context } = {}) {
    return httpAuth2
      .get("/v1/permissions/cosign_supervisors", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<CosignatureSupervisors>();
  },

  get_user_permissions: function ({ context, urlParams }) {
    return httpAuth2
      .get(`/v1/user/${urlParams.userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<UserPermissions>();
  },

  update_user_permissions: function ({ body, context, urlParams }) {
    return httpAuth2
      .post(`/v1/user/${urlParams.userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        json: body,
      })
      .json<UserPermissions>();
  },
};
